if (typeof G == 'undefined') G = {};

G.GridArray = function(width,height,value,dbg) {

	if (typeof width == 'number') {

		this.createGrid.apply(this,arguments);
		
	} else if (typeof width == "string")  {

		this.data = JSON.parse(arguments[0]);
		this.width = this.data.length;
		this.height = this.data[0].length;

	} else if (Array.isArray(width)) {
		a = arguments[0];
		this.data = arguments[0];
		this.width = this.data.length; 
		this.height = this.data[0].length;

	}

};

G.GridArray.prototype = {

	createGrid: function(width,height,value) {

		this.data = []; 
		this.width = width;
		this.height = height;

		for (var collumn = 0; collumn < width; collumn++) {
			this.data[collumn] = [];
			for (var row = 0; row < height; row++) {
				this.data[collumn][row] = value;
			}
		}

	},

	set: function(x,y,val) {
		if (this.isInGrid(x,y)) {
			return this.data[x][y] = val;
		}else {
			if (this.dbg) console.log("setValue OUT OF RANGE");
			return false;
		}
	},

	get: function(x,y) {
		if (this.isInGrid(x,y)) {
			return this.data[x][y];
		}else {
			if (this.dbg) console.log("getValue OUT OF RANGE");
			return false;
		}
	},

	swapValues: function(x1,y1,x2,y2) {

		if (this.isInGrid(x1,y1) && this.isInGrid(x2,y2)) {
			var tmp = this.data[x1][y1];
			this.data[x1][y1] = this.data[x2][y2];
			this.data[x2][y2] = tmp;
		}else {
			if (this.dbg) console.log("swapValues OUT OF RANGE");
			return false;
		}
		
	},

	isInGrid: function(x,y) {
		return !(x < 0 || x >= this.width || y < 0 || y >= this.height);
	},


	find: function(func,context) {

		for (var coll = 0; coll < this.width; coll++) {
			for (var row = 0; row < this.height; row++) {
				var val = func.call(context,this.data[coll][row],coll,row,this.data);
				if (val) return this.data[coll][row];
			}
		}

		return false;

	},


	filter: function(func,context) {

		var result = [];

		for (var coll = 0; coll < this.width; coll++) {
			for (var row = 0; row < this.height; row++) {
				var val = func.call(context,this.data[coll][row],coll,row,this.data);
				if (val) result.push(this.data[coll][row]);
			}
		}

		return result;
	},


	loop: function(func,context) {

		for (var coll = 0; coll < this.width; coll++) {
			for (var row = 0; row < this.height; row++) {
				func.call(context,this.data[coll][row],coll,row,this.data);
			}
		}
	},

	clear: function(value) {
		this.loop(function(elem,x,y,array) {
			array[x][y] = value || false;
		});
	},

	findPattern: function(positions,mark) {

		var result = false;
		var len = positions.length;

		this.loop(function(elem,x,y,array) {
			if (elem == mark && !result) {

				for (var i = 0; i < len; i+=2) {
					//console.log('pos: '+(x+positions[i])+'x'+(y+positions[i+1])+' val: ' + this.get(x+positions[i],y+positions[i+1]));
					if (!this.get(x+positions[i],y+positions[i+1])) return;
					if (this.get(x+positions[i],y+positions[i+1]) !== mark) return;
				}

				//console.log("PASSED FIRST LOOP "+x+'x'+y);
				result = [];
				for (var j = 0; j < len; j+=2) {
					result.push(x+positions[j],y+positions[j+1]);
				}
				//console.log('got patt: ');
				//console.log(x+'x'+y);
				//console.log(result);


			}
		},this);

		return result;

	},

	count: function(){

		var result = 0;

		for (var coll = 0; coll < this.width; coll++) {
			for (var row = 0; row < this.height; row++) {
				if (this.data[coll][row]) {
					result++;
				}
			}
		}

		return result;

	},

	getAllElements: function(){

		var result = [];

		for (var coll = 0; coll < this.width; coll++) {
			for (var row = 0; row < this.height; row++) {
				if (this.data[coll][row]) {
					result.push(this.data[coll][row]);
				}
			}
		}

		return result;

	}


};